// @flow
import { connect } from 'react-redux';

import userActions from 'actions/user';

import ChangePasswordSuccessView from './RecoverPasswordSuccessView';

// Map Props
const mapStateToProps = (state) => ({
});

// Map Dispatch
const mapDispatchToProps = () => ({
});

// Container Component
const ChangePasswordSuccessPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePasswordSuccessView);

export default ChangePasswordSuccessPage;
